import { countOfCartItems } from '@bulknutrients/bulk-shared-lib/lib/cart';
import { Button } from '@components/Button';
import { Icons } from '@components/Icons/Icons';
import { TooltipWrapper } from '@components/Tooltip/Tooltip';
import { useCart } from '@hooks/cart/useCart';
import { useRouter } from 'next/router';
import { type ReactElement, useEffect, useState } from 'react';

const ICON_SIZE = '1.75rem';

export const CartItemsCountButton = ({ handleCartEvent }): ReactElement => {
  const [itemsCount, setItemsCount] = useState(0);
  const router = useRouter();
  const { cart } = useCart();

  const disabled =
    router.asPath.includes('/cart') || router.asPath.includes('/info');

  useEffect(() => {
    let mounted = true;

    if (!cart) {
      setItemsCount(0);
      return;
    }

    const newItemsCount = countOfCartItems(cart);
    if (mounted) setItemsCount(newItemsCount);

    return function cleanup() {
      mounted = false;
    };
  }, [cart]);

  return (
    <TooltipWrapper text="Cart">
      <Button
        aria-label="Cart"
        onClick={handleCartEvent}
        disabled={disabled}
        className="relative h-10 w-10 self-center overflow-visible px-1 text-xs ring-grey-mid ring-offset-2 hover:scale-110 hover:rounded-full hover:bg-white hover:text-black hover:ring-1 hover:ring-grey-mid disabled:text-grey-mid dark:hover:bg-grey-dark dark:hover:text-white dark:disabled:bg-transparent xl:flex"
        buttonStyle="tertiary"
        icon={<Icons.Cart size={ICON_SIZE} />}
      >
        {itemsCount > 0 && !disabled && (
          <span className="absolute right-0 top-0 flex h-4 w-4 items-center justify-center rounded-full bg-red font-primary text-xs text-white">
            <span>{itemsCount}</span>
          </span>
        )}
      </Button>
    </TooltipWrapper>
  );
};
